const DEFAULT_LENGTH = 10;

// Excludes visually ambiguous characters (I, l, 1, O, 0) since a titular
// reads this off a screen and copies it, or worse, retypes it by hand.
const CHARSET = 'ABCDEFGHJKMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';

/**
 * A random temporary password for "Restablecer contraseña" (docs/FLOWS.md
 * §2): the titular confirms via ConfirmAction with no text entry, so the
 * client mints the value itself, sends it to the reset endpoint, and shows
 * it back once — the server never returns it since it only stores a hash.
 */
export function generateTemporaryPassword(length: number = DEFAULT_LENGTH): string {
  const values = crypto.getRandomValues(new Uint32Array(length));
  return Array.from(values, (value) => CHARSET[value % CHARSET.length]).join('');
}
